const initialState = {
  payments: [],
  payment: null,
  paymentLoading: false,
  loading: false,
  error: null,
  isAlreadyDone: false,
};

const paymentReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "FETCH_PAYMENTS_LOADING":
      return { ...state, loading: true, error: null };
    case "FETCH_PAYMENTS_SUCCESS":
      return { ...state, loading: false, payments: payload, error: null };
    case "FETCH_PAYMENTS_ERROR":
      return { ...state, loading: false, error: payload };

    case "CREATE_PAYMENT_LOADING":
      return { ...state, paymentLoading: true, error: null };
    case "CREATE_PAYMENT_SUCC":
      return { ...state, paymentLoading: false, payment: payload, error: null };
    case "CREATE_PAYMENT_ERROR":
      return { ...state, paymentLoading: false, error: payload };

    case "VALIDATE_PAYMENT_LOADING":
      return {
        ...state,
        paymentLoading: true,
        error: null,
        isAlreadyDone: false,
      };
    case "VALIDATE_PAYMENT_SUCC":
      return {
        ...state,
        paymentLoading: false,
        error: null,
        isAlreadyDone: payload === "Payment already done",
      };
    case "VALIDATE_PAYMENT_ERR":
      return {
        ...state,
        paymentLoading: false,
        error: payload,
        isAlreadyDone: false,
      };

    default:
      return state;
  }
};

export default paymentReducer;
